import { FormCheckbox, FormInput, FormRadio, FormSelect } from "@/components";
import { IMarket, IMarketCreate } from "@/models";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
    components: {
        ValidationProvider,
        ValidationObserver,
        FormSelect,
        FormCheckbox,
        FormRadio,
        FormInput,
    },
})
export default class NewMarket extends Vue {
    isOpen = true;

    public tab = "tab-1";

    public market: IMarketCreate = {
        name: "",
        code: "",
        parentId: null,
    };

    get markets(): IMarket[] {
        return this.$store.getters["app/markets"];
    }

    @Watch("tab")
    resetForm(): void {
        this.reset();
    }

    @Watch("isOpen")
    returnToPreviousRoute(): void {
        if (!this.isOpen) {
            this.$router.back();
        }
    }

    reset(): void {
        this.market = {
            code: "",
            name: "",
            parentId: null,
        };

        setTimeout(() => {
            const observer = this.$refs.observer as InstanceType<
                typeof ValidationObserver
            >;
            observer.reset();
        });
    }

    async submit(): Promise<void> {
        try {
            await this.$store.dispatch(`app/createMarket`, this.market);
            this.$emit("success", `The market has been successfully created`);
            this.$router.back();
        }
        catch (error) {
            this.$emit("error", error);
        }
    }

    close(): void {
        this.isOpen = false;
    }

    mounted(): void {}
}
